import api from "../atlasApi";

export const serviceAddLog = (data, token) => {
  return api.post("/horizon/add-edit-task-log/", data, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Token " + token,
    },
  });
};
